export default "__VITE_ASSET__VifvHJhc__"